// uploadJsonUtil.js

/**
 * Initialization function to put results in local storage. 
 */
export const initializeResults = () => {
  const remainingScreens = [
    "screen_2",
    "screen_3",
    "screen_4",
    "screen_5",
    "screen_6",
    "screen_6_b",
    "screen_7",
    "screen_7_b",
    "screen_7_c",
    "screen_8",
    "screen_8_b",
    "screen_8_c",
    "screen_8_d",
    "screen_9",
    "screen_9_b",
    "screen_9_c",
    "screen_9_d",
    "screen_10",
    "screen_11",
    "screen_11_b",
    "screen_11_c",
    "screen_11_d",
    "screen_12",
    "screen_12_b",
    "screen_13",
    "screen_13_b",
    "screen_13_c",
    "screen_13_d",
    "screen_13_e",
    "screen_13_f",
    "screen_13_g",
    "screen_13_h",
    "screen_13_i",
    "screen_13_j",
    "screen_13_k",
    "screen_13_l",
    "screen_14",
    "screen_14_b",
    "screen_14_c",
    "screen_14_d",
    "screen_15",
    "screen_16",
    "screen_16_b",
    "screen_16_c",
    "screen_17",
    "screen_17_b",
    "screen_17_c",
    "screen_17_d",
    "screen_18",
    "screen_18_b",
    "screen_18_c",
    "screen_18_d",
    "screen_19",
    "screen_20",
  ];
  const results = {};
  remainingScreens.forEach((screen) => {
    results[screen] = null;
  });
  localStorage.setItem("results", JSON.stringify(results));
};

/**
 * This is a function to update the local storage with the results from the current screen.
* @param {Object} Value - The params object return by the S3 params generator.
* @param {string} screenId - The name of the corresponding key in the results dictionary, held in local storage.
*/
export const UpdateLocalStorage = (Value, screenId) => {
  const results = JSON.parse(localStorage.getItem("results"));
  results[screenId] = Value;
  localStorage.setItem("results", JSON.stringify(results));  
};